import React from "react";
import { MixmindUniverse, useUniverse } from "../../context/UniverseContext";

export function overlayClassForUniverse(universe: MixmindUniverse): string {
  switch (universe) {
    case MixmindUniverse.Academy:
      return "mixmind-academy-overlay";
    case MixmindUniverse.Play:
      return "mixmind-play-overlay";
    case MixmindUniverse.Assist:
      return "mixmind-assist-overlay";
    default:
      return "";
  }
}

export function UniverseBackgroundOverlay() {
  const { universe } = useUniverse();
  const cls = overlayClassForUniverse(universe);

  if (!cls) return null;

  return <div className={`pointer-events-none fixed inset-0 z-0 ${cls}`} />;
}
